import { render, staticRenderFns } from "./RectificationDialog.vue?vue&type=template&id=b049b7c8&scoped=true&"
import script from "./RectificationDialog.vue?vue&type=script&lang=js&"
export * from "./RectificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./RectificationDialog.vue?vue&type=style&index=0&id=b049b7c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b049b7c8",
  null
  
)

export default component.exports